import Vue from 'vue';
import HeatLossCalc from './HeatLossCalc.vue';

const HeatLossCalcApp = new Vue({
    el: '#heat-loss-calc-app',
    data: {},
    mounted: function () {
        console.log('Mounted');
    },
    components: {
        'heat-loss-calc': HeatLossCalc,
    }
});
